// Listener PWA API — session-scoped, separate from the Studio (JWT) client.
const BACKEND = process.env.REACT_APP_BACKEND_URL;

async function errFrom(r) {
  let detail = "Something went wrong.";
  try {
    const j = await r.json();
    if (j && j.detail) detail = typeof j.detail === "string" ? j.detail : JSON.stringify(j.detail);
  } catch { /* ignore */ }
  const e = new Error(detail);
  e.status = r.status;
  e.detail = detail;
  return e;
}

export async function startSession(inviteToken) {
  const r = await fetch(`${BACKEND}/api/listen/session`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token: inviteToken }),
  });
  if (!r.ok) throw await errFrom(r);
  return r.json();
}

export async function listenFetch(path, token, opts = {}) {
  const headers = { "X-Listen-Session": token, ...opts.headers };
  if (opts.body) headers["Content-Type"] = "application/json";
  const r = await fetch(`${BACKEND}/api${path}`, { ...opts, headers });
  if (!r.ok) throw await errFrom(r);
  return r.json();
}

// Multipart POST (voice notes) — never set Content-Type manually so the browser
// adds the correct multipart boundary.
export async function listenFetchForm(path, token, formData) {
  const r = await fetch(`${BACKEND}/api${path}`, {
    method: "POST", headers: { "X-Listen-Session": token }, body: formData,
  });
  if (!r.ok) throw await errFrom(r);
  return r.json();
}

export function feedbackAudioUrl(feedbackId, token) {
  return `${BACKEND}/api/listen/feedback/${feedbackId}/audio?s=${encodeURIComponent(token)}`;
}

export function audioUrl(itemId, token) {
  return `${BACKEND}/api/listen/audio/${itemId}?s=${encodeURIComponent(token)}`;
}

export function coverUrl(token, version) {
  return `${BACKEND}/api/listen/cover?s=${encodeURIComponent(token)}&v=${encodeURIComponent(version || "")}`;
}

export const SESSION_KEY = "hd_listen_session";
export const INVITE_KEY = "hd_listen_invite";
export const SPEED_KEY = "hd_listen_speed";
export const AUTOPLAY_KEY = "hd_listen_autoplay";
export const INSTALL_DISMISS_KEY = "hd_listen_install_dismissed";
